// @flow
import React, { useCallback } from 'react';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import toast from 'react-hot-toast';

type Props = {
	availableAt: ?Date,
	slug: string,
};

const copyToClipboardFallback = (text) => {
	const textArea = document.createElement('textarea');
	textArea.value = text;
	textArea.style.position = 'fixed';
	textArea.style.left = '-999999px';
	textArea.style.top = '-999999px';
	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();
	try {
		document.execCommand('copy');
		toast.success('Ссылка скопирована в буфер обмена');
	} catch (err) {
		toast.error('Не удалось скопировать ссылку');
	}
	document.body.removeChild(textArea);
};

export const ArticlePreviewTab = ({ availableAt, slug }: Props) => {
	const previewUrl = `https://78.ru/preview/${moment(availableAt).format('YYYY-MM-DD')}/${slug}`;

	const copyPreviewLink = useCallback(() => {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(previewUrl).then(() => {
				toast.success('Ссылка скопирована в буфер обмена');
			}).catch(() => {
				// Fallback для старых браузеров
				copyToClipboardFallback(previewUrl);
			});
		} else {
			// Fallback для старых браузеров
			copyToClipboardFallback(previewUrl);
		}
	}, [previewUrl]);

	return (
		<div style={{marginTop: 20}}>
			<div style={{ marginBottom: 20 }}>
				<a
					href={previewUrl}
					target="_blank"
					rel="noopener noreferrer"
					style={{ marginRight: '16px', color: '#542376', textDecoration: 'underline' }}
				>
					{previewUrl}
				</a>
				<RaisedButton
					label="Копировать ссылку"
					onClick={copyPreviewLink}
					style={{ marginTop: '8px' }}
				/>
			</div>
			<iframe
				className="articlePreview"
				frameBorder={0}
				src={previewUrl}
			/>
		</div>
	);
};




// WEBPACK FOOTER //
// src/components/articles/components/ArticlePreviewTab.js